import { Component, Inject, forwardRef } from '@angular/core';
import { AppComponent } from './app.component';
import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
    selector: 'app-topbar',
    /*template: `
        <div class="topbar clearfix">
            <div class="topbar-left">
                <div class="logo"></div>
            </div>

            <div class="topbar-right">
                <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
                    <i></i>
                </a>

                <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
                    <i class="material-icons">menu</i>
                </a>
                <ul class="topbar-items animated fadeInDown" [ngClass]="{'topbar-items-visible': app.topbarMenuActive}">

                    <li #settings [ngClass]="{'active-top-menu':app.activeTopbarItem === settings}">
                        <a href="#" (click)="salir()" >
                            <i class="topbar-icon material-icons">power_settings_new</i>
                            <span class="topbar-item-name">Salir</span>
                        </a>


                    </li>



                </ul>
            </div>
        </div>*/
        template: `
        <div class="topbar clearfix">
            <div class="topbar-left">
                <div class="logo"></div>
            </div>            
        </div>
    `
})
export class AppTopBar {

    constructor( @Inject(forwardRef(() => AppComponent)) public app: AppComponent, private router: Router,
        private storage: SessionStorageService) { }

    salir() {

        this.storage.store('usuario', null);
        this.storage.store('usuario', null);
        this.storage.store('codigoPostulacion',null);
        this.app.menu = [];
        this.app.resetMenu = true;
        this.app.verificarMenu()
        this.router.navigated = false;
        //window.location.href = "/";
        this.router.navigateByUrl('/');
        location.reload();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.topbar.component.ts